import { ArrowRight, ArrowUpRight } from 'lucide-react'

export function ButtonLink({
  children,
  className = '',
  external = false,
  href,
  variant = 'primary',
}) {
  const Icon = external ? ArrowUpRight : ArrowRight
  const externalProps = external
    ? { rel: 'noreferrer noopener', target: '_blank' }
    : {}

  return (
    <a
      className={`button button-${variant} ${className}`.trim()}
      href={href}
      {...externalProps}
    >
      <span>{children}</span>
      <Icon aria-hidden="true" size={17} strokeWidth={2.4} />
    </a>
  )
}
